export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";